<script>
import { Bar } from 'vue-chartjs'

export default {
  extends: Bar,
  props: ['values', 'barWidth'],
  watch: {
    values() {
      this.chartData.labels = this.values[0].labels
      this.chartData.datasets = this.values
      this.$data._chart.update()
    }
  },
  data () {
    return {
      chartData: {
        labels: [],
        datasets: []
      },
      options: {
        maintainAspectRatio: false,
        tooltips: {
          mode: 'label',
          label: 'mylabel',
          callbacks: {
            label: function(tooltipItem) {
              return 'R$' + tooltipItem.yLabel.toLocaleString(
                undefined, // leave undefined to use the visitor's browser
                // locale or a string like 'en-US' to override it.
                { minimumFractionDigits: 2 })
            }
          }
        },
        scales: {
          xAxes: [
            {
              stacked: true,
              gridLines: {
                color: "#e2e2e2",
                drawOnChartArea: false
              }
            }
          ],
          yAxes: [{
            stacked: true,
            gridLines: {
              color: "#e2e2e2",
              drawOnChartArea: true
            },
            ticks: {
              // Include a dollar sign in the ticks
              callback: function(value) {
                return 'R$' + value.toLocaleString(
                  undefined, // leave undefined to use the visitor's browser
                  // locale or a string like 'en-US' to override it.
                  { minimumFractionDigits: 2 })
              }
            }
          }]
        }
      },
    }
  },
  mounted () {
    this.renderChart(this.chartData, this.options)
  }
}
</script>
